import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { num } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { History, Loader2 } from "lucide-react";

const when = (d) => (d ? new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-");

// Scarichi di una variante: per quale lotto e quando
export const MaterialMovesButton = ({ m }) => {
  const [open, setOpen] = useState(false);
  const { data: rows = [], isLoading } = useQuery({ queryKey: ["materials-stock-moves"], queryFn: async () => (await api.get("/materials/stock-moves")).data, enabled: open, staleTime: 0 });
  const list = rows.filter((r) => r.material_id === m.id);
  const total = list.reduce((s, r) => s + (r.qty || 0), 0);
  return (
    <>
      <Button variant="outline" size="icon" className="h-7 w-7" title="Scarichi" onClick={() => setOpen(true)} data-testid={`mat-moves-${m.id}`}><History className="h-3.5 w-3.5" /></Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto" data-testid={`mat-moves-dialog-${m.id}`}>
          <DialogHeader>
            <DialogTitle>Scarichi · {m.name} {m.color || ""}</DialogTitle>
            <DialogDescription>{m.supplier || ""}{list.length ? ` · totale scalato ${num(total)} ${m.unit}` : ""}</DialogDescription>
          </DialogHeader>
          {isLoading ? <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div> : !list.length ? (
            <p className="py-6 text-center text-sm text-muted-foreground" data-testid={`mat-moves-empty-${m.id}`}>Nessuno scarico per questa variante.</p>
          ) : (
            <Table>
              <TableHeader><TableRow className="hover:bg-transparent"><TableHead>Data</TableHead><TableHead>Per cosa</TableHead><TableHead>Fase</TableHead><TableHead className="text-right">Scalato</TableHead></TableRow></TableHeader>
              <TableBody>
                {list.map((r, i) => (
                  <TableRow key={`${r.batch_id}-${r.stage}-${i}`} data-testid={`mat-move-row-${i}`}>
                    <TableCell className="whitespace-nowrap text-xs">{when(r.date)}</TableCell>
                    <TableCell className="text-sm"><span className="font-medium">{r.product_name}</span> · {r.batch_color || "-"}<span className="block text-[11px] text-muted-foreground">{r.cut_ticket_number ? `${r.cut_ticket_number}° tagliato · ` : ""}lotto {r.batch_number}{r.season ? ` · ${r.season}` : ""}</span></TableCell>
                    <TableCell className="text-xs">{r.stage === "taglio" ? "Passaggio in Taglio" : "Passaggio in Confezione"}</TableCell>
                    <TableCell className="text-right font-semibold">{num(r.qty)} {r.unit}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
